import { render, staticRenderFns } from "./material_cubierta_interior_crud.vue?vue&type=template&id=42464216"
import script from "./material_cubierta_interior_crud.vue?vue&type=script&lang=js"
export * from "./material_cubierta_interior_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports